export const stripeCallback = (type: string, data: any = {}) => ({
	type,
	provider: 'stripe',
	data
})
